import { render, staticRenderFns } from "./Utilities-Detail-Listrik.vue?vue&type=template&id=31c850df"
import script from "./Utilities-Detail-Listrik.vue?vue&type=script&lang=js"
export * from "./Utilities-Detail-Listrik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports